import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Text, Heading, useTooltip, Button } from '@frontend/design-system';
import { useTemplatePreviewContext } from '../provider';
import {
  titleContainerStyle,
  titleStyle,
  headerActionsContainerStyle,
  estimatedTimeContainerStyle,
} from './preview-header.style';
import PreviewModeChanger from './preview-mode-changer/preview-mode-changer.component';

export interface TemplatePreviewHeaderProps {
  copyTemplateBtnTrackingId?: string;
  onUseThisTemplate: () => void;
}

const TemplatePreviewHeader: FC<TemplatePreviewHeaderProps> = ({ copyTemplateBtnTrackingId, onUseThisTemplate }) => {
  const { t } = useTranslation('forms');
  const { template } = useTemplatePreviewContext();
  const {
    tooltipProps: titleTooltipProps,
    triggerProps: titleTooltipTriggerProps,
    Tooltip: TitleTooltip,
  } = useTooltip();
  const {
    tooltipProps: estimatedTimeTooltipProps,
    triggerProps: estimatedTimeTooltipTriggerProps,
    Tooltip: EstimatedTimeTooltip,
  } = useTooltip();

  const { description, name, timeToFill } = template;

  return (
    <>
      <header>
        <div css={titleContainerStyle}>
          <Heading level={2} css={titleStyle}>
            <span {...titleTooltipTriggerProps}>{name}</span>
            <TitleTooltip {...titleTooltipProps}>{name}</TitleTooltip>
          </Heading>

          <div css={headerActionsContainerStyle}>
            <Text as='span'>
              <span css={estimatedTimeContainerStyle} {...estimatedTimeTooltipTriggerProps}>
                <Icon name='clock-small' /> {t('{{count}} mins', { count: timeToFill })}
              </span>
              <EstimatedTimeTooltip {...estimatedTimeTooltipProps}>{t('Estimated time to fill')}</EstimatedTimeTooltip>
            </Text>
            <Button size='small' trackingId={copyTemplateBtnTrackingId} onClick={onUseThisTemplate}>
              {t('Use This Template')}
            </Button>
          </div>
        </div>
        <Text color='light'>{description}</Text>
      </header>
      <PreviewModeChanger />
    </>
  );
};

export default TemplatePreviewHeader;
